(() => {
  const qs = (s, c=document) => c.querySelector(s);
  document.addEventListener('click', (e) => {
    const menuBtn = e.target.closest('[data-rv-menu]');
    if (menuBtn) {
      const menu = qs('[data-rv-mobile]');
      if (menu) {
        const open = menu.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
    const mobileLink = e.target.closest('[data-rv-mobile] a');
    if (mobileLink) {
      const menu = qs('[data-rv-mobile]');
      const btn = qs('[data-rv-menu]');
      if (menu) menu.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded','false');
    }
    const thumb = e.target.closest('[data-rv-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-rv-gallery]');
      const main = gallery && (qs('[data-rv-main]', gallery) || qs('.rv-offer__main img', gallery));
      if (main) {
        main.src = thumb.dataset.src || main.src;
        main.alt = thumb.dataset.alt || main.alt;
        gallery.querySelectorAll('[data-rv-thumb]').forEach(x => x.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-rv-variant]')) {
      const option = e.target.selectedOptions[0];
      const box = e.target.closest('[data-rv-product-form]');
      const price = box && qs('[data-rv-price]', box);
      if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    }
  });
})();
